import makeApiRequest from "../api/makeApiCall";
import { Config } from "../latest/src/constants/AppServerConfig";

const THERAPY_SESSION_URL = `${Config.therapySessionService}therapy-session`;
const WAITING_ROOM_URL = `${Config.therapySessionService}waiting-room-member`;
const THERAPY_SESSION_SERVICE = `${Config.therapysessionservieces}`;

export const getWaitingRoomMembers = async () => {
    return await makeApiRequest(`${WAITING_ROOM_URL}/members`, "GET");
};

/**
 * Client joining the waiting room
 * @param {String} therapistId - current matched therapist id
 * @returns {Promise}
 */

export async function joinWaitingRoom(data: Object) {
    return await makeApiRequest(`${WAITING_ROOM_URL}`, "POST", data);
}

/**
 * Therapist starting the session
 * @param {Object} data - { id, state: 'INVITED_BY_THERAPIST' }
 * @returns {Promise}
 */

// @TO DO: Below api call can be removed
export async function therapistStartSession(data) {
    return await makeApiRequest(`${WAITING_ROOM_URL}/invite`, "POST", data);
}

export async function checkForActiveSession() {
    return await makeApiRequest(`${THERAPY_SESSION_URL}`);
}

export async function getMeetingRoomCredentials() {
    return await makeApiRequest(`${THERAPY_SESSION_URL}/user`);
}

export async function convertToGroupSession() {
    return await makeApiRequest(
        `${THERAPY_SESSION_URL}/convert-to-group-session`,
        "GET"
    );
}

export async function leaveMeetingRoom() {
    return await makeApiRequest(`${THERAPY_SESSION_URL}/leave`, "POST");
}

export async function endTherapySession() {
    return await makeApiRequest(`${THERAPY_SESSION_URL}/end`, "POST");
}

export async function getInfoByAttendeeId(attendeeId: string) {
    return await makeApiRequest(
        `${THERAPY_SESSION_URL}-participant/attendee-id`,
        "POST",
        { attendeeId }
    );
}

// Below mentioned end point can be deleted
export async function leaveWaitingRoom(therapistId: string) {
    return await makeApiRequest(`${WAITING_ROOM_URL}/leave`, "POST", {
        therapistId,
    });
}

// Below mentioned end point can be deleted
export async function enterTherapySession() {
    return await makeApiRequest(`${THERAPY_SESSION_URL}/enter`, "POST");
}

export async function getParticipantsList() {
    // waiting and meeting room
    return await makeApiRequest(`${THERAPY_SESSION_URL}/participants`, "GET");
}

export async function startSessionWithoutCheckin() {
    return await makeApiRequest(`${THERAPY_SESSION_URL}/start`, "GET");
}

export async function reset() {
    return await makeApiRequest(`${WAITING_ROOM_URL}/reset`, "POST");
}

export async function getCheckinByWaitingRoomId(id: any) {
    return await makeApiRequest(
        `${WAITING_ROOM_URL}/${id}/client-checkin-using-sockets`,
        "GET"
    );
}

//  New Endpoints for Teletherapy Refectoring
// ===============================================

export async function getTherapySessions() {
    return await makeApiRequest(
        `${THERAPY_SESSION_SERVICE}/therapy-sessions`,
        "GET"
    );
}

export async function therapistStartSessionNewEndPoint(therapySessionId) {
    return await makeApiRequest(
        `${THERAPY_SESSION_SERVICE}/therapy-sessions/${therapySessionId}/_start`,
        "PUT"
    );
}

export async function clientStartSessionNewEndPoint(therapySessionId) {
    return await makeApiRequest(
        `${THERAPY_SESSION_SERVICE}/therapy-sessions/${therapySessionId}/_join`,
        "PUT"
    );
}

export async function leaveSessionNewEndPoint(therapySessionId) {
    return await makeApiRequest(
        `${THERAPY_SESSION_SERVICE}/therapy-sessions/${therapySessionId}/_leave`,
        "PUT"
    );
}

export async function therapistAcknowledgeSession(therapySessionId) {
    return await makeApiRequest(
        `${THERAPY_SESSION_SERVICE}/therapy-sessions/${therapySessionId}/_acknowledge-notification`,
        "PUT"
    );
}

export async function therapistEndSession(therapySessionId) {
    return await makeApiRequest(
        `${THERAPY_SESSION_SERVICE}/therapy-sessions/${therapySessionId}/_end`,
        "PUT"
    );
}

export async function getTherapySessionChimeData(sessionId: string) {
    return await makeApiRequest(
        `${THERAPY_SESSION_SERVICE}/therapy-sessions/${sessionId}/_get-chime-join-data`,
        "GET"
    );
}

export const clientRequestRematch = async (matchType, sessionId) => {
    return await makeApiRequest(
        `${THERAPY_SESSION_SERVICE}/therapy-sessions/${sessionId}/_rematch-request`,
        "POST",
        { matchType }
    );
};
